import React, { useEffect ,useState} from 'react'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { totalcountapi } from '../../ApiUrl';
import axios from 'axios';
export const token = sessionStorage.getItem("accessToken")
const headers = {
    Authorization: `Bearer ${token}`,   
};
function Home() {
  // console.log(process.env.REACT_APP_APPWRITE_URL)
  const [totalValue, setTotalValue] = useState({})
  const [loading, setLoading] = useState(true);
  const totalapi = async () => {
    try {
      const res = await axios.get(totalcountapi,{headers})
      setTotalValue(res.data.data)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }
  useEffect(() => {
    totalapi()
  })
  const cards = [
    {
      id: 1,
      name: "Adminsion",
      link: "admission",
      icon: "journal-bookmark-fill",
      number: loading ? "loading" : totalValue.totalAddmission,
    },

    {
      id: 2,
      name: "Gallery",
      link: "gallery",
      icon: "image-fill",
      number: loading ? "loading" : totalValue.totalGellery,
    },
    {
      id: 4,
      name: "Video",
      link: "video",
      icon: "file-play-fill",
      number: loading ? "loading" : totalValue.totalVideo,
    },
    {
      id: 5,
      name: "PreeRealse",
      link: "pressrealse",
      icon: "file-image",
      number: loading ? "loading" : totalValue.totalPress,
    },

    {
      id: 6,
      name: "Blogs",
      link: "blog",
      icon: "grid-fill",
      number: loading ? "loading" : totalValue.totalBlog,
    },

    {
      id: 7,
      name: "Query",
      link: "contact",
      icon: "headset",
      number: loading ? "loading" : totalValue.totalContact,
    },
    {
      id: 8,
      name: "Complaint",
      link: "complaint",
      icon: "question-octagon-fill",
      number: loading ? "loading" : totalValue.totalComplaint,
    },

  ]
  return (
    <>
      <div className="row justify-content-start">
        {loading && (
          <>
            {Array.from({ length: 10 }).map((_, index) => (
              <div key={index} className='col-lg-4 col-6'>
                <div className='p-2'>
                  <Skeleton height={100} />
                </div>
              </div>
            ))}
          </>
        )}
        {!loading  && (
          cards.map((_) => (
            <div className="col-lg-4 col-6 my-2" key={_.id}>
              <Link to={_.link}> <div className={`d-flex justify-content-between text-dark p-3 rounded shadow-sm`}>
                <div className='content-center'>
                  <div>
                    <i className={`bi bi-${_.icon} fs-2`}></i>
                    <div className='fw-bold text-primary'>{_.name}</div>
                  </div>
                </div>
                <div className='content-center'>
                  <div className='text-end'>
                    <div className='fs-1'>{_.number}</div>
                  </div>
                </div>
              </div>
              </Link>
            </div>
          ))
        )}

      </div>
    </>
  )
}

export default Home